"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _uuid = require("uuid");

var _optimizelySdk = _interopRequireDefault(require("@optimizely/optimizely-sdk"));

var _arg = _interopRequireDefault(require("@spothero/arg"));

var _environment = _interopRequireDefault(require("../environment/environment"));

var _storage = _interopRequireDefault(require("../storage/storage"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source))).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var IS_BROWSER = _environment.default.isBrowser();

var FEATURE_VARIABLE_TYPES = ['Boolean', 'Double', 'Integer', 'String']; // See https://docs.developers.optimizely.com/full-stack/docs/get-feature-variable

var _segmentExperiments = []; // experiment and variation ids for reporting to Segment

var _client = null;
var _whiteListId = null;
var _idCookieName = null;
var _variationsCookieName = null;
var _serverCookies = {};
var _userAttributes = {};
/**
 * Utilities for working with Optimizely.
 * @module OptimizelyUtils
 */

var OptimizelyUtils = {
  /**
   * @enum {String}
   */
  LOG_LEVEL: _optimizelySdk.default.enums.LOG_LEVEL,

  /**
   * Initialize the Optimizely client with a datafile
   * @static
   * @function initialize
   * @param {Object} datafile - data content provided by Optimizely
   * @param {Object} [options] - Options to pass in.
   * @param {Boolean} [options.isBot] - value to determine if entire block should be skipped
   * @param {Boolean} [options.isDev] - value to determine default logger used
   * @param {Function} [options.loadMechanism] - async fetcher used to get datafile
   * @param {Boolean} [options.isBrowser] - value to determine if reading from server cookie or url params for options
   * @param {Function} [options.onDatafileSuccess] - in the case where a fetch is made for the data file, a function to execute right after
   * @param {Function} [options.onDatafileError] - in the case where a fetch is made for the data file, a function to execute if that fetch fails
   * @param {string} [options.logLevel] - The level to set Optimizely's logger to. See https://docs.developers.optimizely.com/full-stack/docs/customize-logger-javascript#section-log-levels
   * @param {string} [options.idCookieName='sh-experiment-id'] - The name of the id cookie
   * @param {string} [options.variationsCookieName='sh-experiment-variations'] - The name of the variations cookie
   * @param {string} [options.serverCookies={}] - Cookies that originated from a server request in SSR environments
   * @return {Object} Returns the Optimizely client and the datafile (the one passed in, or the newly fetched one)
   */
  initialize: function initialize(datafile) {
    var _arguments = arguments,
        _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _ref, _ref$isBot, isBot, _ref$isDev, isDev, _ref$isBrowser, isBrowser, _ref$logLevel, logLevel, _ref$serverCookies, serverCookies, _ref$loadMechanism, loadMechanism, _ref$onDatafileError, onDatafileError, _ref$onDatafileSucces, onDatafileSuccess, _ref$idCookieName, idCookieName, _ref$variationsCookie, variationsCookieName, df, sCookies, logLvl, _yield$loadMechanism, data, experimentIdCookie, variationsCookie, _Arg$parse, optimizelyX, optimizelyLog, parsedIdCookie, variations;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref$isBot = _ref.isBot, isBot = _ref$isBot === void 0 ? false : _ref$isBot, _ref$isDev = _ref.isDev, isDev = _ref$isDev === void 0 ? false : _ref$isDev, _ref$isBrowser = _ref.isBrowser, isBrowser = _ref$isBrowser === void 0 ? true : _ref$isBrowser, _ref$logLevel = _ref.logLevel, logLevel = _ref$logLevel === void 0 ? null : _ref$logLevel, _ref$serverCookies = _ref.serverCookies, serverCookies = _ref$serverCookies === void 0 ? {} : _ref$serverCookies, _ref$loadMechanism = _ref.loadMechanism, loadMechanism = _ref$loadMechanism === void 0 ? null : _ref$loadMechanism, _ref$onDatafileError = _ref.onDatafileError, onDatafileError = _ref$onDatafileError === void 0 ? null : _ref$onDatafileError, _ref$onDatafileSucces = _ref.onDatafileSuccess, onDatafileSuccess = _ref$onDatafileSucces === void 0 ? null : _ref$onDatafileSucces, _ref$idCookieName = _ref.idCookieName, idCookieName = _ref$idCookieName === void 0 ? 'sh-experiment-id' : _ref$idCookieName, _ref$variationsCookie = _ref.variationsCookieName, variationsCookieName = _ref$variationsCookie === void 0 ? 'sh-experiment-variations' : _ref$variationsCookie;
              df = datafile;
              sCookies = serverCookies;
              logLvl = logLevel;

              if (!isBot) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", _promise.default.resolve({
                df: df
              }));

            case 6:
              if (!(!df && !loadMechanism)) {
                _context.next = 8;
                break;
              }

              throw new Error("Missing required argument \"datafile\". No \"loadMechanism\" supplied so wont try and make the fetch.");

            case 8:
              if (!(!df && loadMechanism)) {
                _context.next = 22;
                break;
              }

              _context.prev = 9;
              _context.next = 12;
              return loadMechanism('/experiments/optimizely-datafile/');

            case 12:
              _yield$loadMechanism = _context.sent;
              data = _yield$loadMechanism.data;
              df = data;

              if (onDatafileSuccess) {
                onDatafileSuccess();
              }

              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](9);

              if (!onDatafileError) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return", onDatafileError(_context.t0));

            case 22:
              // actual server cookies need to be JSON.parsed
              experimentIdCookie = (0, _get.default)(sCookies, 'sh-experiment-id', null);
              variationsCookie = (0, _get.default)(sCookies, 'sh-experiment-variations');

              if (isBrowser) {
                sCookies = {
                  'sh-experiment-id': experimentIdCookie,
                  'sh-experiment-variations': variationsCookie
                };

                if ((0, _get.default)(window, 'location.search', false)) {
                  _Arg$parse = _arg.default.parse(window.location.search), optimizelyX = _Arg$parse.optimizely_x, optimizelyLog = _Arg$parse.optimizely_log;

                  if (optimizelyX) {
                    _whiteListId = optimizelyX;
                  }

                  if (optimizelyLog) {
                    logLvl = optimizelyLog;
                  }
                }
              } else {
                parsedIdCookie = null;
                variations = null;

                try {
                  parsedIdCookie = JSON.parse(experimentIdCookie);
                } catch (err) {
                  parsedIdCookie = experimentIdCookie;
                }

                try {
                  variations = JSON.parse(variationsCookie);
                } catch (err) {
                  variations = variationsCookie || null;
                }

                sCookies = {
                  'sh-experiment-id': parsedIdCookie,
                  'sh-experiment-variations': variations
                };
              }

              _idCookieName = idCookieName;
              _variationsCookieName = variationsCookieName;

              if (sCookies) {
                _serverCookies = sCookies; // set browser cookies that may have originated on the server side

                if (IS_BROWSER) {
                  _this.createIdCookie(_serverCookies[_idCookieName]);

                  _this.updateVariationsCookie(_serverCookies[_variationsCookieName]);
                }
              }

              if (!logLvl && isDev) {
                logLvl = 'ERROR';
              }

              _client = _optimizelySdk.default.createInstance({
                datafile: df,
                logger: _optimizelySdk.default.logging.createLogger({
                  logLevel: OptimizelyUtils.LOG_LEVEL[logLvl],
                  logToConsole: Boolean(logLvl)
                })
              }); // https://segment.com/docs/destinations/optimizely-web/#optimizely-full-stack-javascript
              // See section titled Optimizely Full Stack (JavaScript) - Getting Started
              // This is required for Optimizely/Segment integration

              if (isBrowser) {
                window.optimizelyClientInstance = _client;
              }

              return _context.abrupt("return", {
                client: _client,
                datafile: df
              });

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 18]]);
    }))();
  },

  /**
   * Checks whether the Optimizely client is initialized.
   * @static
   * @function isInitialized
   * @example OptimizelyUtils.isInitialized();
   * @return {Boolean} - Whether the client is initialized.
   */
  isInitialized: function isInitialized() {
    return Boolean(_client);
  },

  /**
   * Sets the logger level for the Optimizely client.
   * @static
   * @function setLogLevel
   * @param {String} [logLevel='ERROR'] - The level to set. Possible values are null (disable logger), 'INFO', 'DEBUG', 'WARN', and 'ERROR'.
   * @example OptimizelyUtils.setLogLevel('INFO');
   * @return {void}
   */
  setLogLevel: function setLogLevel() {
    var logLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ERROR';

    _optimizelySdk.default.setLogLevel(logLevel);
  },

  /**
   * Sets the logger the Optimizely client.
   * @static
   * @function setLogger
   * @param {Object} [options=null] - The options to pass to the logger. Passing null will disable logging. See <a href="https://docs.developers.optimizely.com/full-stack/docs/customize-logger-javascript">docs</a>.
   * @example OptimizelyUtils.setLogger();
   * @return {void}
   */
  setLogger: function setLogger() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _optimizelySdk.default.setLogger(options ? _optimizelySdk.default.logging.createLogger(options) : null);
  },

  /**
   * Checks Optimizely to see if the user is bucketed in this experiment
   * Activates the experiment for the current session; an impression will be sent to Optimizely
   * Appends the experiment name and variation name to a cookie (used by analytics and the Reservations API)
   * @static
   * @function activate
   * @param {String} experimentName - Experiment name
   * @example OptimizelyUtils.activate('mw_checkout_value_props') => 'vp_below';
   * @return {String} variationName - For each variation, returns the name of the variation assigned to this user, or 'a'
   */
  activate: function activate(experimentName) {
    if (!experimentName) {
      throw new Error("Missing required argument \"experimentName\".");
    }

    if (_client) {
      var variationName;

      if (IS_BROWSER) {
        variationName = _client.activate(experimentName, this.getId(), _userAttributes) || 'a';
      } else {
        variationName = this.getVariation(experimentName);
      }

      this.updateVariationsCookie((0, _defineProperty3.default)({}, experimentName, variationName));
      this.updateSegmentExperiments({
        experimentName: experimentName,
        variationName: variationName,
        type: 'ab-test'
      });
      return variationName;
    }

    return 'a';
  },

  /**
   * Checks if a feature is enabled for a user
   * @static
   * @function isFeatureEnabled
   * @param {String} featureName - The name of the feature
   * @example OptimizelyUtils.isFeatureEnabled('web_canada');
   * @returns {Boolean} isEnabled - Whether or not the feature is enabled for this user
   */
  isFeatureEnabled: function isFeatureEnabled(featureName) {
    var _this2 = this;

    if (!featureName) {
      throw new Error("Missing required argument \"featureName\".");
    }

    if (_client) {
      // There is no option to check isFeatureEnabled (on server-side) without potentially generating an impression
      // Since isFeatureEnabled is used for both feature experiments and rollouts, this call cannot be substituted with getVariation
      var isFeatureEnabled = _client.isFeatureEnabled(featureName, this.getId(), _userAttributes);

      if (isFeatureEnabled) {
        var featureExperiments = this.getExperimentsAndVariationsForFeature(featureName);
        (0, _forEach.default)(featureExperiments).call(featureExperiments, function (experiment) {
          var experimentName = experiment.experimentName,
              variationName = experiment.variationName;

          _this2.updateVariationsCookie((0, _defineProperty3.default)({}, experimentName, variationName));

          _this2.updateSegmentExperiments(_objectSpread(_objectSpread({}, experiment), {}, {
            type: 'feature-test'
          }));
        });
      }

      return isFeatureEnabled;
    }

    return false;
  },

  /**
   * Checks Optimizely to see if the user is bucketed in this experiment
   * Does not activate the experiment for the current session; no impression will be sent to Optimizely
   * @static
   * @function getVariation
   * @param {String} experimentName - Name of experiment
   * @example OptimizelyUtils.getVariation('homepage_tabbed_search') => 'tabbed_with_value_props';
   * @return {String} variationName - For each variation, returns the name of the variation assigned to this user, or 'a'
   */
  getVariation: function getVariation(experimentName) {
    if (!experimentName) {
      throw new Error("Missing required argument \"experimentName\".");
    }

    if (_client) {
      return _client.getVariation(experimentName, this.getId(), _userAttributes) || 'a';
    }

    return 'a';
  },

  /**
   * @static
   * @function getFeatureVariable
   * @param {Object} requiredParams - All params are required
   * @param {String} requiredParams.featureName - The name of the feature
   * @param {String} requiredParams.variableName - The name of the feature variable
   * @param {String} requiredParams.type - The type of the feature variable
   * @example OptimizelyUtils.getFeatureVariable({
   *      featureName: 'web_canada',
   *      variableName: 'search_enabled',
   *      type: 'Boolean',
   * });
   * @returns {Double|Integer|String|Boolean} variableValue - The value of the given variable and type for the given feature
   */
  getFeatureVariable: function getFeatureVariable(requiredParams) {
    var _context2;

    var missingArguments = (0, _filter.default)(_context2 = (0, _keys.default)(requiredParams)).call(_context2, function (param) {
      return !requiredParams[param];
    });

    if (missingArguments.length) {
      throw new Error("Missing required argument(s): ".concat(missingArguments.join(', ')));
    }

    if (_client) {
      var featureName = requiredParams.featureName,
          variableName = requiredParams.variableName,
          type = requiredParams.type;
      var formattedType = type[0].toUpperCase() + type.substr(1).toLowerCase();

      if (!(0, _find.default)(FEATURE_VARIABLE_TYPES).call(FEATURE_VARIABLE_TYPES, function (supportedType) {
        return supportedType === formattedType;
      })) {
        var _context3;

        throw new Error((0, _concat.default)(_context3 = "Type must be one of: ".concat(FEATURE_VARIABLE_TYPES.join(', '), ". Given type: ")).call(_context3, type));
      }

      return _client["getFeatureVariable".concat(formattedType)](featureName, variableName, this.getId(), _userAttributes);
    }

    return false;
  },

  /**
   * Get values of feature variables for the given feature
   * @static
   * @function getEnabledFeatureVariables
   * @param {String} featureName - Name of the enabled feature
   * @param {Array} featureVariables - Array containing feature variable name and type
   * @example OptimizelyUtils.getEnabledFeatureVariables('filter_sort', [
   *   ['sort_distance', 'Boolean'],
   *   ['sort_price', 'String'],
   *   ['filters', 'Integer'],
   *   ['map', 'Double'],
   * ]);
   * @returns {Object} - Returns dictionary of variable name/value key/value pairs
   */
  getEnabledFeatureVariables: function getEnabledFeatureVariables(featureName, featureVariables) {
    var _this3 = this;

    return (0, _reduce.default)(featureVariables).call(featureVariables, function (allVariables, _ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          variableName = _ref3[0],
          type = _ref3[1];

      return _objectSpread(_objectSpread({}, allVariables), {}, (0, _defineProperty3.default)({}, variableName, _this3.getFeatureVariable({
        featureName: featureName,
        variableName: variableName,
        type: type
      })));
    }, {});
  },

  /**
   * Return experiment names and variations for a given feature
   * @static
   * @function getExperimentsAndVariationsForFeature
   * @param {String} featureName - Name of feature flag
   * @returns {Array} featureExperiments - Array of objects, each containing experiment information
   */
  getExperimentsAndVariationsForFeature: function getExperimentsAndVariationsForFeature(featureName) {
    var _this4 = this;

    if (_client) {
      var _client$getOptimizely = _client.getOptimizelyConfig(),
          featuresMap = _client$getOptimizely.featuresMap;

      var experiments = featuresMap[featureName].experimentsMap;
      var featureExperiments = [];
      (0, _forEach2.default)(experiments, function (_ref4) {
        var id = _ref4.id,
            key = _ref4.key,
            variationsMap = _ref4.variationsMap;
        featureExperiments.push({
          id: id,
          experimentName: key,
          variationName: _this4.getVariation(key)
        });
      });
      return featureExperiments;
    } else {
      return [];
    }
  },

  /**
   * Return the serverCookies object.
   * @static
   * @function getServerCookies
   * @returns {Object} - The cookies from the server request.
   */
  getServerCookies: function getServerCookies() {
    return _serverCookies;
  },

  /**
   * Return the value of the id cookie (or create new cookie and return its value)
   * @static
   * @function getIdCookie
   * @returns {String} - Either the existing cookie or a new value from a new cookie
   */
  getIdCookie: function getIdCookie() {
    var shExperimentCookie = IS_BROWSER ? _storage.default.get(_idCookieName, 'cookie') : _serverCookies[_idCookieName];
    return !(0, _isNil.default)(shExperimentCookie) ? shExperimentCookie.toString() : this.createIdCookie();
  },

  /**
   * Create a unique ID and store it in the id cookie
   * @static
   * @function createIdCookie
   * @param {String} id - An ID to set as the id cookie
   * @returns {String} uuid - Creates a unique ID and stories it in the id cookie
   */
  createIdCookie: function createIdCookie(id) {
    var uuid = id || (0, _uuid.v4)();

    if (IS_BROWSER) {
      _storage.default.set(_idCookieName, uuid, 'cookie', 365);
    } else {
      _serverCookies[_idCookieName] = uuid;
    }

    return uuid;
  },

  /**
   * Return user id for use with Optimizely SDK
   * @static
   * @function getId
   * @returns {String} Either the id cookie value or the value passed to the optimizely_x query param
   */
  getId: function getId() {
    return _whiteListId || this.getIdCookie();
  },

  /**
   * Return the experiment names and variations stored in the variations cookie
   * @static
   * @function getVariationsCookie
   * @returns {Object} keys are experiment names and corresponding values are variation names.
   */
  getVariationsCookie: function getVariationsCookie() {
    var shVariationsCookie = IS_BROWSER ? _storage.default.get(_variationsCookieName, 'cookie') || {} : _serverCookies[_variationsCookieName];
    return shVariationsCookie;
  },

  /**
   * Update the experiment names and variations stored in the variations cookie
   * @static
   * @function updateVariationsCookie
   * @param {Object} newVariations - New object where key is experiment name corresponding value is variation name
   * @example updateVariationsCookie({'mw_checkout_value_props': 'vp_below'});
   * @returns {void}
   */
  updateVariationsCookie: function updateVariationsCookie(newVariations) {
    var currentVariations = this.getVariationsCookie();

    var updatedVariations = _objectSpread(_objectSpread({}, currentVariations), newVariations);

    if (IS_BROWSER) {
      _storage.default.set(_variationsCookieName, updatedVariations, 'cookie', 365);
    } else {
      _serverCookies[_variationsCookieName] = updatedVariations;
    }
  },

  /**
   * Clear the experiment names and variations stored in the variations cookie
   * @static
   * @function clearVariationsCookie
   * @returns {void}
   */
  clearVariationsCookie: function clearVariationsCookie() {
    if (IS_BROWSER) {
      _storage.default.set(_variationsCookieName, {}, 'cookie', 365);
    } else {
      _serverCookies[_variationsCookieName] = {};
    }
  },

  /**
   * Returns experiment data formatted specifically for Segment
   * @static
   * @function getSegmentExperiments
   * @returns {Array} - Array with object for each active experiment
   */
  getSegmentExperiments: function getSegmentExperiments() {
    return _segmentExperiments;
  },

  /**
   * Update experiment data formatted specifically for Segment
   * @static
   * @function getSegmentExperiments
   * @param {String} experimentName - Name of experiment
   * @param {String} variationName - Name of experiment variation
   * @param {String} type - 'ab-test' | 'feature-test'
   * @returns {void}
   */
  updateSegmentExperiments: function updateSegmentExperiments() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        experimentName = _ref5.experimentName,
        variationName = _ref5.variationName,
        type = _ref5.type;

    if (_client) {
      var _client$getOptimizely2 = _client.getOptimizelyConfig(),
          experimentsMap = _client$getOptimizely2.experimentsMap;

      if (variationName !== 'a') {
        var variationObj = experimentsMap[experimentName].variationsMap[variationName];
        /* eslint-disable camelcase */

        _segmentExperiments.push({
          experiment_name: experimentName,
          experiment_id: experimentsMap[experimentName].id,
          variation_name: variationName,
          variation_id: variationObj.id,
          type: type
        });
        /* eslint-enable camelcase */

      }
    }
  },

  /**
   * Add attributes to be sent along with requests for feature and experiment values.
   * Attributes must be configured in Optimizely and appear in the datafile to be captured correctly
   * @static
   * @function setUserAttributes
   * @param {Object} userAttributes - Supported attributes are defined in our Optimizely implementation
   * @param {Object} [options] - Options to pass in
   * @param {Object} [options.reset] - Remove any existing attributes before setting new ones
   * @returns {void}
   */
  setUserAttributes: function setUserAttributes(userAttributes) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$reset = _ref6.reset,
        reset = _ref6$reset === void 0 ? false : _ref6$reset;

    _userAttributes = _objectSpread(_objectSpread({}, !reset && _userAttributes), userAttributes);
  },

  /**
   * Clears the associated Optimizely client instance.
   * @static
   * @function clearClient
   * @returns {void}
   */
  clearClient: function clearClient() {
    _client = null;
  }
};
var _default = OptimizelyUtils;
exports.default = _default;